var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"help-link",attrs:{"href":_vm.href,"target":"_blank"}},[_c('icon-default',{attrs:{"icon":_vm.icon,"size":"is-small"}}),_vm._v(" "),_c('span',{staticClass:"ml-50"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }